import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { NBCTStyleCoursePlayer } from '@/components/course/NBCTStyleCoursePlayer';

export default function CoursePlayer() {
  const { courseId } = useParams<{ courseId: string }>();
  const navigate = useNavigate();

  if (!courseId) {
    return (
      <div className="flex h-screen bg-background">
        <div className="flex-1 flex flex-col items-center justify-center">
          <div className="text-center space-y-4">
            <h2 className="text-2xl font-bold">Course Not Found</h2>
            <p className="text-muted-foreground">The course you're looking for could not be found.</p>
            <Button onClick={() => navigate('/')}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Return Home
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return <NBCTStyleCoursePlayer courseId={courseId} />;
}